import { render, staticRenderFns } from "./information-individu.vue?vue&type=template&id=7ab5364d&scoped=true&"
import script from "./information-individu.vue?vue&type=script&lang=ts&"
export * from "./information-individu.vue?vue&type=script&lang=ts&"
import style0 from "./information-individu.vue?vue&type=style&index=0&id=7ab5364d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab5364d",
  null
  
)

export default component.exports